module.exports = "/build/web/images/banner/banner.a4ccda627fd4d380fd521c054b95a439.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/banner/banner.jpg
// module id = 119
// module chunks = 24